import { Badge } from "react-bootstrap";
import { useNotificationContext } from "../../../context/notifications";
import "./styles.css";

const NotificationsIconMenu = () => {
  const { notifications, setShowNotification } = useNotificationContext();
  const success = notifications.filter((i) => i.variant === "success").length;
  const warning = notifications.filter((i) => i.variant === "warning").length;
  const danger = notifications.filter((i) => i.variant === "danger").length;

  return (
    <div style={{ alignContent: "center" }}>
      {notifications.length > 0 && (
        <Badge
          className="d-flex flex-row align-items-center mx-2 py-2 button"
          bg="#696969"
          style={{ backgroundColor: "#696969", maxWidth: "100px" }}
          onClick={() => {
            setShowNotification(true);
          }}
        >
          <Badge
            pill
            bg="danger"
            className={`mx-1 text-center ${danger ? "animated-badge" : ""}`}
          >
            {danger}
          </Badge>
          <Badge
            pill
            bg="warning"
            className={`mx-1 text-center ${warning ? "animated-badge" : ""}`}
          >
            {warning}
          </Badge>
          <Badge
            pill
            bg="success"
            className={`mx-1 text-center ${success ? "animated-badge" : ""}`}
          >
            {success}
          </Badge>
        </Badge>
      )}
    </div>
  );
};

export default NotificationsIconMenu;
